import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import RequestItemsTable from '../../RequestItemsTable';
import type { SupplierRequestDraftItem } from '../../model/types';

interface TabRequestProps {
    items: SupplierRequestDraftItem[];
    note: string;
    vendorNote: string;
    fileUrl: string;
}

const TabRequest = ({ items, note, vendorNote, fileUrl }: TabRequestProps) => {
    const { t } = useTranslation(['Warehouses']);
    const [showNotes, setShowNotes] = useState(false);
    const hasNotes = Boolean(note || vendorNote);

    return (
        <>
            <div className="my-3">
                <RequestItemsTable
                    items={items}
                    disabled
                    showActions={false}
                    showReceived
                />
            </div>

            {(fileUrl || hasNotes) ? (
                <div className="mb-3">
                    <div>
                        {fileUrl ? (
                            <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="small d-inline-block me-3"
                            >
                                <i className="bi bi-file-earmark-pdf me-1" aria-hidden="true" />
                                {t('supplierRequests.openPdf')}
                            </a>
                        ) : null}

                        {hasNotes ? (
                            <Button
                                type="button"
                                size="sm"
                                variant="link"
                                className="p-0 align-baseline d-inline-block"
                                onClick={() => setShowNotes((prev) => !prev)}
                            >
                                <i
                                    className={`bi ${showNotes ? 'bi-eye-slash' : 'bi-sticky'} me-1`}
                                    aria-hidden="true"
                                />
                                {showNotes
                                    ? t('supplierRequests.view.hideNotes')
                                    : t('supplierRequests.view.showNotes')}
                            </Button>
                        ) : null}
                    </div>

                    {hasNotes && showNotes ? (
                        <div className="mt-2 d-flex flex-column gap-2">
                            {note ? (
                                <div className="border rounded bg-light p-3">
                                    <div className="text-muted f-12 mb-1">
                                        {t('supplierRequests.create.noteLabel')}
                                    </div>
                                    <div className="small mb-0 text-break">{note}</div>
                                </div>
                            ) : null}
                            {vendorNote ? (
                                <div className="border rounded bg-light p-3">
                                    <div className="text-muted f-12 mb-1">
                                        {t('supplierRequests.create.vendorNoteLabel')}
                                    </div>
                                    <div className="small mb-0 text-break">{vendorNote}</div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </>
    );
};

export default TabRequest;
